module.exports = __webpack_public_path__ + "img/Case_5.ffa8e5de.jpg";